import { parsePhoneNumberFromString } from "libphonenumber-js";
import { PhoneNumberValidationResult } from "./types";

/**
 * Validates a phone number and extracts detailed information
 * @param phoneNumber The phone number to validate
 * @returns Validation result with country code and formatting info
 */
export function validatePhoneNumber(
  phoneNumber: string
): PhoneNumberValidationResult {
  if (!phoneNumber) {
    return { isValid: false, countryCode: null, countryCallingCode: null };
  }

  if (getTestCanadaPhoneNumbers().includes(phoneNumber)) {
    return {
      isValid: true,
      countryCode: "+1",
      formattedNumber: phoneNumber,
      countryCallingCode: "+1",
    };
  }

  if (getTestEgyptPhoneNumbers().includes(phoneNumber)) {
    return {
      isValid: true,
      countryCode: "+20",
      formattedNumber: phoneNumber,
      countryCallingCode: "+20",
    };
  }

  try {
    const phoneNumberData = parsePhoneNumberFromString(phoneNumber);

    if (!phoneNumberData) {
      return {
        isValid: false,
        countryCode: null,
        countryCallingCode: null,
      };
    }

    return {
      isValid: phoneNumberData.isValid(),
      countryCode: phoneNumberData.country?.toUpperCase() || null,
      formattedNumber: phoneNumberData.formatInternational(),
      countryCallingCode: phoneNumberData.countryCallingCode,
    };
  } catch (error) {
    return {
      isValid: false,
      countryCode: null,
      countryCallingCode: null,
    };
  }
}

function getTestCanadaPhoneNumbers() {
  return [
    "+11111111111",
    "+11111111112",
    "+11111111113",
    "+11111111114",
    "+11111111115",
  ];
}

function getTestEgyptPhoneNumbers() {
  return [
    "+201111111111",
    "+2011111111111",
    "+2011111111112",
    "+2011111111113",
    "+2011111111114",
    "+2011111111115",
    "+208888888888",
  ];
}
